import { ReactNode } from 'react'
import cx from 'classnames'
import { BrandPlanTactic } from 'types'
import Styles from './V4ChannelSelection.module.scss'

export interface ChannelDef {
  id: string
  label: string
  icon: ReactNode
  tactic: BrandPlanTactic | null
}

interface ChannelPillProps {
  channel: ChannelDef
  isSelected: boolean
  onToggle?: (id: string) => void
  readOnly?: boolean
}

export const ChannelPill = ({ channel, isSelected, onToggle, readOnly }: ChannelPillProps) => {
  if (readOnly) {
    return (
      <span className={cx(Styles.pill, Styles.pillReadOnly)}>
        <span className={Styles.pillIcon}>{channel.icon}</span>
        <span className={Styles.pillLabel}>{channel.label}</span>
      </span>
    )
  }

  return (
    <button
      type="button"
      className={cx(Styles.pill, { [Styles.pillSelected]: isSelected })}
      onClick={() => onToggle?.(channel.id)}
      aria-pressed={isSelected}
    >
      <span className={Styles.pillIcon}>{channel.icon}</span>
      <span className={Styles.pillLabel}>{channel.label}</span>
      {isSelected && (
        <span className={Styles.pillCheck}>
          <svg width="10" height="10" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M4 8.43233C4.79279 9.0089 6.37838 10.5945 7.02703 11.6756C7.81982 9.94584 9.83784 6.05395 12 4.32422"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </span>
      )}
    </button>
  )
}
